module.exports = __webpack_public_path__ + "img/s5.9c5ccfd2.png";